import { AspContact, AspContactsRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspCustomers() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [customers, setCustomers] = useState<AspContact[]>([]);

  async function fetchAspCustomers(params: AspContactsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAspCustomers(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setCustomers(res.Customers);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, customers, fetchAspCustomers };
}
